/*
|--------------------------------------------------------------------------
| JS Objects
|--------------------------------------------------------------------------
*/

Array.prototype.move = function(from, to) {
     // remove and get the from value, then insert that into the “to” position
    this.splice(to, 0, this.splice(from, 1)[0]);
};


Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};







/*
|--------------------------------------------------------------------------
| JQuery Plugins
|--------------------------------------------------------------------------
*/
/**
 * Check to see if something is on screen
 * http://upshots.org/javascript/jquery-test-if-element-is-in-viewport-visible-on-screen
 * @param {number} offset - number of pixels to offset, 75 would trigger 75 pixels before item is in view
 * @example
 * if($('#element').isOnScreen){ //do something }
 */
$.fn.isOnScreen = function(offset){
	var offset 	= (typeof offset !== 'undefined') ? offset : 0;
    var element = this.get(0);
    var bounds 	= element.getBoundingClientRect();
   // alert(bounds.top +"< ("+window.innerHeight+" + "+offset+") && "+bounds.bottom+" > 0");
   // alert(bounds.top < (window.innerHeight + offset) && bounds.bottom > 0);
    return bounds.top < (window.innerHeight + offset) && bounds.bottom > 0;
};

/**
 * Check to see if a click was made outside an element
 * https://jsfiddle.net/bkuxa04p/
 * @example
 * if($('#element').clickOff){ //do something }
 */
$.fn.clickOff = function(callback) {
    var element = this;
    $(document).on('click', function(event) {
      if (!$(event.target).closest(element).length) {
      	callback(element, event);
      }
    });
};

/**
 * Get the index of an element within a container
 */
$.fn.getIndex = function(){
	  var $p=$(this).parent().children();
    return $p.index(this);
}







/*
|--------------------------------------------------------------------------
| Common JS Methods
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.common = __gh__webApp.common || {};


/**
 * Divide numbers and round the result
 * @param {integer} - Number to divide into
 * @param {integer} - Number to divide by
 */
__gh__webApp.common.divideAndRound = function(numberToDivideInto, numberToDivideBy) {
	return Math.ceil(numberToDivideInto / numberToDivideBy);
};
	


/**
 * Use Debounce when you have something like an on scroll event that can be intensive.
 * Returns a function, that, as long as it continues to be invoked, will not be triggered. 
 * The function will be called after it stops being called for N milliseconds. 
 * @param {function} func - function that you want to be called
 * @param {number} wait - number of milliseconds to wait before function is called again
 * @param {boolean} immediate - if `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 */
__gh__webApp.common.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};


/**
 * Filter array of arrays/objects by a property and value
 * @namespace
 * @param {object} options
 * @param {array} options.data - array of data objects/arrays
 * @param {string} options.property - property/index to filter on
 * @param {string} options.value - value to filter on
 */
__gh__webApp.common.filterBy = function(options){
		var data 		= (options.data) 		? options.data 		: null,
			property 	= (options.property) 	? options.property 	: null,
			value 		= (options.value) 		? options.value 	: null;
		var newData = data.filter(function( obj ) {
		  return obj[property] == value;
		});
    	return newData;
};


/**
 * Get a cookie
 * @namespace
 * @param {string} cookieName - name of the cookie
 */
 __gh__webApp.common.getCookie = function(cookieName) {
	return Cookies.get(cookieName);
};


/**
 * Get the page title with a page number appended
 * https://jsfiddle.net/84wbmtkL/5/
 * @namespace
 * @param {string} title - name of the cookie
 * @param {string} pageNumber - page number
 * @param {string} [pageNubmerLabel=Page] - override label for page number 
 * @example
 * getPageTitleWithPageNumber({"title":pageTitle,"pageNumber":pageNumber});
 */
__gh__webApp.common.getPageTitleWithPageNumber = function(options){
	var title 			= (options.title) ? options.title : document.title,
		pageNumber		= (options.pageNumber) ? options.pageNumber : null,
		pageNumberLabel = (options.pageNumberLabel) ? options.pageNumberLabel : "Page", 
		pattern		= new RegExp("(- Page (\\d)+ |)- "+pageNumberLabel+" (\\d)+");
    return title.replace(pattern,"") + " - "+ pageNumberLabel +" " + pageNumber;
};


/**
 * Set a cookie
 * @namespace
 * @param {object} options
 * @param {string} options.name - name of the cookie
 * @param {string} options.value - cookie value
 * @param {string} options.expires - days to expire
 * @param {string} options.domain - site domain
 * @param {string} options.path - limit cookie to a certain path
 */
__gh__webApp.common.setCookie = function(options){
	 
	var name 			= ("name" in options) ? options.name : null,
		value			= ("value" in options) ? options.value : null,
		cookieOptions	= {};
	
	if (!name && !value) { return; }
	
	if ("domain" in options) {
		cookieOptions.domain 	=  options.domain;
	}
	
	if ("expires" in options) {
		cookieOptions.expires 	=  options.expires;
	}
	
	if ("path" in options) {
		cookieOptions.path 		=  options.path;
	}
	
	Cookies.set(name, value, cookieOptions);
};



/**
 * Returns a random number
 */
 __gh__webApp.common.getRandomNumber = function() {
    return Math.floor(Math.random()*100);
};


/**
 * Get a single url parameter from a querystring
 * @param  {string} param The field to get the value of
 * @param  {string} url   The URL to get the value from (optional)
 * @return {string}       The field value
 */
__gh__webApp.common.getURLParam = function ( param, url ) {
    var url = url ? url : window.location.href;
    var reg = new RegExp( '[?&]' + param + '=([^&#]*)', 'i' );
    var string = reg.exec(url);
    return string ? string[1] : null;
};


/**
 * Return a day of the week for a date
 *
 * @param {object} date - javascript new Date() object
 * @param {string} length - "long" or "short"
 * @param {boolean} utc - true or false for utc date format ("2016-01-15")
 */
__gh__webApp.common.getDayName = function(date,length,utc) {
	var date 		= (date) ? date : new Date(),
		length 		= (length) ? length : "long",
		longDays 	= ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
		shortDays 	= ['Sun.','Mon.','Tue.','Wed.','Thur.','Fri.','Sat.'],
		day			= (utc) ? date.getDay() : date.getUTCDay();
		
	if (length=="long") {
		return longDays[day];
	}
	
	return shortDays[day];
};


/**
 * Return the name of a month for a date
 *
 * @param {object} date - javascript new Date() object
 * @param {string} length - "long" or "short"
 * @param {boolean} utc - true or false for utc date format ("2016-01-15")
 */
__gh__webApp.common.getMonthName = function(date,length,utc) {
	var date 		= (date) ? date : new Date(),
		length 		= (length) ? length : "long",
		longMonths 	= ['January','February','March','April','May','June','July','August','September','October','November','December'],
		shortMonths = ['Jan.','Feb.','Mar.','Apr.','May','Jun.','Jul.','Aug.','Sept.','Oct.','Nov.','Dec.'],
		day			= (utc) ? date.getUTCMonth() : date.getMonth();
		
		if (length=="long") {
			return longMonths[day];
		}
		
		return shortMonths[day];
};



/**
 * Return formatted time
 *
 * @param {object} date - javascript new Date() object
 * @param {boolean} utc - true or false for utc date format ("2016-01-15")
 */
__gh__webApp.common.getTimeFormatted = function(date,utc) {
	// formats a javascript Date object into a 12h AM/PM time string
	var hour 	= (utc) ? date.getUTCHours() : date.getHours(),
		minute 	= (utc) ? date.getUTCMinutes() :  date.getMinutes(),
		amPM 	= (hour > 11) ? "PM" : "AM";
		
	if(hour > 12) {
		hour -= 12;
	}
	
	if (hour == 0) {
		hour = "12";
	}
	
	if(minute < 10) {
		minute = "0" + minute;
	}
	
	return hour + ":" + minute + "&nbsp;" + amPM;
};


/**
 * Parse url into parts
 * https://gist.github.com/jlong/2428561
 * https://jsfiddle.net/y1guc958/
 * @param  {string} [url=window.location.href] - The URL to parse (optional)
 * @return {object} - parsed url object
 * @example
 * var parser = parseURL("http://example.com:3000/pathname/?search=test#hash");
 * parser.protocol; // => "http:"
 * parser.hostname; // => "example.com"
 * parser.port;     // => "3000"
 * parser.pathname; // => "/pathname/"
 * parser.search;   // => "?search=test"
 * parser.hash;     // => "#hash"
 * parser.host;     // => "example.com:3000"
 */
__gh__webApp.common.getURLParts = function (url) {
    var url 		= url ? url : window.location.href,
    	parser 		= document.createElement('a');
		parser.href = url;
    return parser;
};


/**
 * Go to a url
 * @param  {string} url   The URL to send the user to
 */
__gh__webApp.common.goToURL = function(url){
	document.location.href = url;
};

/**
 * Update url with the url params passed to the function
 * @param {object} options
 * @param {string} [options.url=location.href] - url to update
 * @param {object} options.params - params to update/add to the url
 * https://jsfiddle.net/Lgc6Lcvg/
 */
__gh__webApp.common.updateURLParams = function(options){
	var url 		= (options.url) 		? options.url 		: location.href,
		params 		= (options.params) 		? options.params 	: null;
	for (param in params) {
		var value  = params[param],
		    pattern = new RegExp('\\b('+param+'=).*?(&|$)',"i");
		if(url.search(pattern)>=0){
		    url = url.replace(pattern,'$1' + value + '$2');
		    continue;
		}
		var questionAmp = (url.indexOf('?')>0) ? '&' : '?';
		url = url + questionAmp + param + '=' + value;
	}
	return url;
};



/**
 * Get the full query string as an object of parameters
 * @param  {string} [url=urlInLocationBar] - The URL to get the parameters from.  Default is the location bar
 * @return {object} - An object of parameters
 */
__gh__webApp.common.getURLParamsAsObject = function(url) {            
    var queryString = (url) ? url.split('?')[1] : location.search.slice(1),
    	pairs 		= queryString.split('&');
    
    var result = {};
    pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
};


/**
 * Test if url is relative
 * https://jsfiddle.net/8232bq88/1/
 * @param  {string} [url] - The URL to test.
 * @return {boolean}
 */
__gh__webApp.common.isURLRelative = function(url) {            
    var url 		= (url) 		? url : null,
    	pattern 	= /^https?:\/\//i;
    if (!url) {return false;}
	if (pattern.test(url)) {
	   return false;
	}
	return true;
};


/**
 * No Cache a url if nocache is in the live url
 * @param  {string} [url] - The URL to test.
 * @return {boolean}
 */
__gh__webApp.common.noCacheURL = function(url){
	if (!this.getURLParam("nocache")){ return url; }
	url = this.updateURLParams({
		"url": url,
		"params": {"NoCache":1}
	});
	return url;
};


/**
 * Remove URL params
 * @param {object} options
 * @param {string} [options.url=location.href] - url to update
 * @param {array} options.params - params to remove from url
 * https://jsfiddle.net/mL2nLpwo/
 */
__gh__webApp.common.removeURLParams = function(options){
	var url 		= (options.url) 		? options.url 		: location.href,
		params 	= (options.params) 		? options.params 	: null;
	for (i=0; i < params.length; i++) {
		var value  = params[i],
		    pattern = new RegExp('\\b('+params[i]+'=).*?(&|$)',"i");
		if(url.search(pattern)>=0){
		    url = url.replace(pattern,"");
		    continue;
		}
	}
	url = url.replace(/(\&|\?)$/, '');
	return url;
};


/**
 * Updates the page number in a url
 * https://jsfiddle.net/37n2q69j/3/
 * @param {object} options
 * @param {string} options.url - url to update
 * @param {integer} options.pageNumber - page number to update.
 */
__gh__webApp.common.updateURLPageNumber = function(options){
	var url 				= (options.url) 		? options.url 			: location.href,
		pageNumber 			= (options.pageNumber) 	? options.pageNumber 	: null,
		pageNumberPattern 	= new RegExp('\\/page\\/(\\d+)'),
		pagePath			= "/page/"+pageNumber;

	//page/x already exits in the url
	if(url.search(pageNumberPattern)>=0){
		return url.replace(pageNumberPattern,pagePath);
	}
	
	//page/x doesn't exist in the url
	var removeTrailingSlashPattern 	= new RegExp("\\/$"),
		urlParts 	= url.split("?"),
		newURL 		= urlParts[0].replace(removeTrailingSlashPattern, "") + pagePath;
		var newURL 	= (urlParts.length > 1) ? newURL + "?" + urlParts[1] : newURL;
	return newURL;
};


/**
 * Get page number from the url
 * https://jsfiddle.net/59685nr6/
 * @param  {string} url - The URL to get the value from (optional)
 * @return {string} - page number
 */
__gh__webApp.common.getURLPageNumber = function ( url ) {
    var url 		= url ? url : window.location.href,
    	urlParts 	= url.split("?"),
    	regex 		= new RegExp( "/page/(\\d+)", 'i' ),
    	matches 	= regex.exec(urlParts[0]),
      	pageNumber	= (matches) ? matches[1] : null;
    return pageNumber;
};


/**
 * Get url path
 * https://jsfiddle.net/59685nr6/
 * @param  {string} url - The URL to get the value from (optional)
 * @return {string} - page number
 */
__gh__webApp.common.getURLPath = function ( url ) {
    var url = url ? url : window.location.href;
	if (this.isURLRelative(url)) {
		return url;
	} 
	var urlParts 	= this.getURLParts(url);
		urlPath		= urlParts.pathname + urlParts.search;
	return urlPath;
};


/**
 * Search string varaible for a string.
 * @namespace
 * @param {string} myVar - string to search within
 * @param {string} searchString - string to search for
 */
__gh__webApp.common.hasString = function(myVar,searchString)
{
	if (myVar.indexOf(searchString) !== -1) {
		return true;
	}
	return false;
};


/**
 * Test if value is in array
 * https://jsfiddle.net/tfz3jcc1/1/
 *
 * @param {array} myArray - array to check for value
 * @param {array} myValue - value to check in array
 * @param {boolean} caseInsensitive - setting to true will lowercase everything and compare
 * @example
 * var myArray = ["value1","value2"]; console.log(inArray("value1",myArray)); //true
 */
__gh__webApp.common.inArray = function(myValue,myArray,caseInsensitive) {
	if (!caseInsensitive){
		return (myArray.indexOf(myValue) !== -1);
	}
	
	//Lowercase everything
	var lowerCaseArray = myArray.join('~~~~').toLowerCase().split('~~~~');
	return (lowerCaseArray.indexOf(myValue.toLowerCase()) !== -1);
};



/**
 * Test if variable is an array
 *
 * @param {array} myArray - var that will be tested
 * @example
 * var myArray = []; console.log(isArray(myArray)); //true
 */
__gh__webApp.common.isArray = function(myArray) {
    return myArray.constructor.toString().indexOf("Array") > -1;
};


/**
 * Test if array is empty
 *
 * @param {array} myArray - var that will be tested
 * @example
 * var myArray = []; console.log(isArrayEmpty(myArray)); //true
 */
__gh__webApp.common.isArrayEmpty = function(myArray) {
	return (typeof myArray !== 'undefined' && myArray.length != 0) ? false : true;
};


/**
 * Test if a number is even
 * @param {integer} num - number you would like to test
 * @example
 * var num = 5; isEven(num); // true
 */
__gh__webApp.common.isEven = function(num) { 
	return !this.isOdd(num);
};


/**
 * Test if variable is a function
 *
 * @param {object} obj - var that will be tested
 * @example
 * var obj = function(){}; console.log(isFunction(obj)); //true
 */
__gh__webApp.common.isFunction = function(obj) {
  return Object.prototype.toString.call(obj) == '[object Function]';
};



/**
 * Test if variable is a number
 *
 * @param {number} num - var that will be tested
 * @example
 * var num = 5; console.log(isNumber(num)); //true
 */
__gh__webApp.common.isNumber = function(num) {
  return typeof num == 'number';
};


/**
 * Test if variable is a object
 *
 * @param {object} obj - var that will be tested
 * @example
 * var obj = {}; console.log(isObject(obj)); //true
 */
__gh__webApp.common.isObject = function(obj) {
  return typeof obj == 'object';
};



/**
 * Test if object is empty
 *
 * @param {object} obj - var that will be tested
 * @example
 * var obj = {}; console.log(objectIsEmpty(obj)); //true
 */
__gh__webApp.common.isObjectEmpty = function(obj) {
	return (Object.keys(obj).length != 0) ? false : true;
};


__gh__webApp.common.isObjectEquivalent = function(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false;
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
};


/**
 * Check to see if a property exists in a nested object
 * @param {object} obj - Object to check
 * @param {string} prop - Property to test
 * @example
 * var obj = {"jason": {"check":{}}};
 * alert(isNestedObjectPropertySet(obj, 'jason.check.id')); //false
 */
__gh__webApp.common.isObjectPropertySet = function(obj, prop) {
    var parts = prop.split('.');
    for(var i = 0, l = parts.length; i < l; i++) {
        var part = parts[i];
        if(obj !== null && typeof obj === "object" && part in obj) {
            obj = obj[part];
        }
        else {
            return false;
        }
    }
    return true;
};


/**
 * Get an object property using dot notation
 * https://jsfiddle.net/2jchkfjv/
 * @param {object} object - Object
 * @param {string} property - Property to retrieve
 * @param {string} defaultValue - pass if you want something besides null returned if nothing is found
 * @example
 * var siteCookie = {"newsletter": {"modalForm":{"expires":1}}};
 * alert(getObjectProperty(siteCookie, 'newsletter.modalForm.expires')); //false
 */
__gh__webApp.common.getObjectProperty = function(object, property, defaultValue) {
    var parts = property.split('.');
    for(var i = 0, l = parts.length; i < l; i++) {
        var part = parts[i];
        if(object !== null && typeof object === "object" && part in object) {
           object = object[part];
        }
        else {
	    	return (defaultValue) ? defaultValue : null;
        }
    }
    return object;
};


/**
 * Clean object of null or undefined values
 * @param {object} object - object to clean
 */
__gh__webApp.common.cleanObject = function(object){
  var properties = Object.getOwnPropertyNames(object);
  for (var i = 0; i < properties.length; i++) {
    var property = properties[i];
    if (object[property] === null || object[property] === undefined) {
      delete object[property];
    }
  }
  return object;
};


/**
 * Test if a number is multiple of 
 * @param {integer} num - number you would like to test ie. 25
 * @param {integer} multipleOf - check to see if "num" is a multiple of this number
 * @example
 * var num = 25, multipleOf= 5; isMultipleOf(num,multipleOf); // true
 */
__gh__webApp.common.isMultipleOf = function(num,multipleOf) { 
	return !(num % multipleOf);
};


/**
 * Test if a number is odd
 * @param {integer} num - number you would like to test
 * @example
 * var num = 5; isOdd(num); // true
 */
__gh__webApp.common.isOdd = function(num) { 
	return num % 2;
};



/**
 * Get everything after a certain character in a string
 *
 * @param {string} string - string to search
 * @param {string} character - get everything in the string after this character
 * @example
 * var string = "obj.test1.test2"; var char = "."; console.log(getStringAfterChar(string,character)); // "test1.test2"
 */
__gh__webApp.common.getStringAfterChar = function(string,character){
   return string.substring(string.indexOf(character) + 1);
};



/**
 * Dynamically load a script tag onto the page
 * @namespace
 * @param {object} options
 * @param {boolean} [options.async=true] - turn async on or off
 * @param {string} [options.class] - class name for script tag
 * @param {object} [options.dataAttributes] - object of data properties to be set...don't need prepend "data-"
 * @param {string} [options.id] - id attribute for the script tag
 * @param {string} [options.onload] - name of a function that should run after script has loaded
 * @param {string} [options.src] - src attribute for the script tag, link to script file
 * @param {string} [options.tagName="head"] - tag name that the script tag should be appended to
 * @param {string} [options.text] - if you want a tag that has js between it - you can use http://www.freeformatter.com/javascript-escape.html to escape the string
 */
__gh__webApp.common.loadScript = function(options) {

	var async						= ("async" in options)				?	options["async"] 				: true,
		className					= (options["class"])				?	options["class"]				: null,
		dataAttributes				= (options.dataAttributes)			?	options.dataAttributes			: {},
		id							= (options.id)						?	options.id						: null,
		onload						= (options.onload)					?	options.onload					: null,
		src 						= (options.src) 					? 	options.src 					: null,
		tagName						= (options.tagName)					?	options.tagName 				: "head",
		text						= (options.text)					?	options.text					: null;
		
	
	//Check to see if script has been loaded
	if (src){
		var isScriptLoaded = $('script[src*="'+src+'"]').length;
		if (isScriptLoaded !== 0) {return false;}
	}
	
	//Add Script to head
    var dom 	= document.getElementsByTagName(tagName)[0],
		script 	= document.createElement('script');
		
	
	//Set script attributes
	script.async 						= async;
	if (className) 	{ script.className	= className; }
	if (id)			{ script.id			= id;		 }
	if (onload)		{ script.onload		= onload;	 }
	if (src)		{ script.src		= src;		 }
	if (text)		{ script.text		= text;		 }
	
	
	//Add data attributes
	if (!this.isObjectEmpty(dataAttributes)){
		//Add data attributes
		for (var prop in dataAttributes) {
		  var dataProp = 'data-'+prop;
		  script[dataProp] = dataAttributes[dataProp];
		}
	}
 
	//Append to dom
    dom.appendChild(script);
    
    return true;
};


/**
 * Uses Jquery to merge two objects
 *
 * @param {object} object1
 * @param {object} object2
 * @example
 * var object1 = {"first":"Barney"}; var object2={"last":"Fife"}; console.log(mergeObjects(object1,object2)); // {"first":"Barney","last":"Fife"}
 */
__gh__webApp.common.mergeObjects = function(object1,object2){
   return $.extend(object1, object2);
};


/**
 * Recursive function uses each element of an array to drill down a level deeper into an object.
 *
 * http://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
 * @param {object} obj - object that will be accessed
 * @param {array} array - array of strings that will be used to access properties of the object
 * @example
 * obj,"1.2.3" -> ((obj['1'])['2'])['3']
 */
__gh__webApp.common.stringToObjNode = function(obj,str) { 
    function index(obj,i) {return obj[i]}
	return str.split('.').reduce(index, obj);
};


/**
 * Convert a string in dot notation to an existing function
 *
 * @param {string} string - string in dot notation or no dots if it's just a function
 * @example <caption>Example dot notation</caption>
 * var testObj = {"1":{"2":{"3":function(){alert('hello world');}}}};
 * var fn = stringToFunction("testObj.1.2.3"); fn();
 * @example <caption>Example without dot notation</caption>
 * var fn = stringToFunction("priosort"); fn();
 */
__gh__webApp.common.stringToFunction = function(fnPath){
	var fnPathParts = fnPath.split('.');
	if (fnPathParts.length > 1){
		var obj 	= window[fnPathParts[0]],
			fnPath 	= this.getStringAfterChar(fnPath,'.'),
			fn 		= this.stringToObjNode(obj,fnPath);
		if (this.isFunction(fn)){return fn;}
		return false;
	}
	if (window[fnPath] && this.isFunction(window[fnPath])){
		return window[fnPath];
	}
	return false;
};


/**
 * Pass an array of functions that can be called
 *
 * @namespace
 * @param {array} functionsArray - array of functions to be called [{"callback":"functionName","data":"dataToPass"}]
 * @example
 * __gh__webApp.common.callArrayOfFunctions([{"callback":"__gh__webApp.data.sortBy.date"}])
 */
 __gh__webApp.common.callArrayOfFunctions = function(functionsArray){
	 
	if(functionsArray.length == 0){ return; }
	for(var i=0; i<functionsArray.length ;i++){
		__gh__webApp.common.callFunction(functionsArray[i]);
	}
};


/**
 * Pass a function object that can be called
 * @example
 * __gh__webApp.common.callFunctions({"callback":"__gh__webApp.data.sortBy.date"})
 */
__gh__webApp.common.callFunction = function(functionObject){
	 
	var callback = functionObject.callback,
		fn = (this.isFunction(callback)) ? callback : __gh__webApp.common.stringToFunction(callback);
	
	if (fn){
		if ("data" in functionObject){
			return fn(functionObject.data);
		}
		return fn();
	}
};


/**
 * Get current time in milliseconds
 */
__gh__webApp.common.timer = function(){
	var currentTime = new Date().getTime();
	
	return currentTime;
};


/**
 * Encrypt - crypto-js
 * @param {string} message - string that you want to encrypt
 * @param {string} password - password you use to encrypt and decrypt it

__gh__webApp.common.encrypt = function(message,password) {
   return CryptoJS.AES.encrypt(message, password).toString()
};
*/


/**
 * Decrypt - crypto-js
 * @param {string} encryptedMessage - encrypted message
 * @param {string} password - password you use to encrypt and decrypt it

__gh__webApp.common.decrypt = function(encryptedMessage,password) {
   return CryptoJS.AES.decrypt(encryptedMessage,password).toString(CryptoJS.enc.Utf8)
};
*/